// File: src/components/LoginView.js
// Login screen component

import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

function LoginView({ onLogin, onCancel }) {
  const { t } = useLanguage();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loginError, setLoginError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoginError('');
    
    const result = await onLogin(username, password);
    if (!result.success) {
      setLoginError(result.error);
    }
  };

  return (
    <div className="app-shell flex items-center justify-center p-4">
      <div className="bg-paper rounded-lg p-8 max-w-md w-full border border-line">
        <h2 className="text-3xl font-bold text-ink mb-6 text-center">{t('login')}</h2>

        {loginError && (
          <div className="bg-red-50 dark:bg-red-500/20 border border-red-500 text-red-800 dark:text-red-200 px-4 py-3 rounded mb-4">
            {loginError}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="space-y-4">
            <div>
              <label className="block text-ink-muted mb-2">{t('username')}</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full px-4 py-2 bg-paper-alt border border-line rounded text-ink"
                autoFocus
              />
            </div>
            <div>
              <label className="block text-ink-muted mb-2">{t('password')}</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-2 bg-paper-alt border border-line rounded text-ink"
              />
            </div>
          </div>

          {/* Competitors can recover their own account; staff ask an administrator. */}
      <button
        type="button"
        onClick={() => { window.location.hash = '#/forgot'; }}
        className="mt-4 text-sm text-blue-700 dark:text-blue-400 hover:opacity-80"
      >
        {t('forgotPassword')}
      </button>

      <div className="mt-6 flex gap-3">
            <button
              type="submit"
              className="flex-1 bg-accent hover:opacity-90 text-accent-ink py-2 px-4 rounded font-semibold"
            >
              {t('login')}
            </button>
            <button
              type="button"
              onClick={onCancel}
              className="flex-1 bg-paper-alt hover:opacity-80 text-ink py-2 px-4 rounded font-semibold"
            >
              {t('cancel')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default LoginView;